import { useEffect, useState } from 'react';
import { PHASE_IDS, phaseForDate, phaseWeights } from './timeOfDay';

const STORAGE_KEY = 'glk.hero.phase';

function readStored() {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return PHASE_IDS.includes(v) ? v : 'auto';
  } catch {
    return 'auto';
  }
}

/** mode: 'auto' follows the local clock, otherwise a pinned phase id. */
export function useTimeOfDay() {
  const [mode, setModeState] = useState(readStored);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(id);
  }, []);

  const setMode = (next) => {
    setModeState(next);
    try {
      if (next === 'auto') window.localStorage.removeItem(STORAGE_KEY);
      else window.localStorage.setItem(STORAGE_KEY, next);
    } catch { /* storage unavailable: choice lasts for this visit */ }
  };

  const auto = mode === 'auto';
  return {
    mode,
    setMode,
    phase: auto ? phaseForDate(now) : mode,
    // Auto only: per-phase opacity so the photos cross-fade before each boundary.
    weights: auto ? phaseWeights(now.getHours() + now.getMinutes() / 60) : null,
  };
}
